import type { payloadType } from '@/hooks/tracking/useLazyTrack';

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
function track({
  type,
  payload,
  method,
}: {
  type: string;
  payload: payloadType;
  method: string;
}) {
  if (!window.analytics) {
    console.log('tracking analytics not loaded'); // eslint-disable-line no-console
    return;
  }
  if (method === 'page') {
    window.analytics.page(type, payload);
  } else {
    window.analytics.track(type, payload);
  }
}

export default track;
